
import { useState } from 'react'
import { Search, Settings } from 'lucide-react'
import { LookupPage } from '@/components/LookupPage'
import { MyNodePage } from '@/components/MyNodePage'

type Tab = 'lookup' | 'mynode'

export function HomePage() {
  const [activeTab, setActiveTab] = useState<Tab>('lookup')

  return (
    <div className="min-h-screen">
      {/* Mobile Navigation */}
      <div className="md:hidden border-b border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex space-x-1">
            <button
              onClick={() => setActiveTab('lookup')}
              className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2 ${
                activeTab === 'lookup'
                  ? 'bg-primary-100 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              <Search size={18} />
              <span>Lookup</span>
            </button>
            <button
              onClick={() => setActiveTab('mynode')}
              className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center justify-center space-x-2 ${
                activeTab === 'mynode'
                  ? 'bg-primary-100 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              <Settings size={18} />
              <span>My Node</span>
            </button>
          </nav>
        </div>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <nav className="flex justify-center space-x-1 mb-8">
            <button
              onClick={() => setActiveTab('lookup')}
              className={`px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center space-x-2 ${
                activeTab === 'lookup'
                  ? 'bg-primary-100 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              <Search size={18} />
              <span>Lookup</span>
            </button>
            <button
              onClick={() => setActiveTab('mynode')}
              className={`px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center space-x-2 ${
                activeTab === 'mynode'
                  ? 'bg-primary-100 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              <Settings size={18} />
              <span>My Node</span>
            </button>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        {activeTab === 'lookup' && <LookupPage />}
        {activeTab === 'mynode' && <MyNodePage />}
      </main>
    </div>
  )
}